export const PRIVATE_NAV = [
  { key: 'overview', path: '/admin/private', end: true, labelKey: 'adminPrivate.tabs.overview' },
  { key: 'inquiries', path: '/admin/private/inquiries', labelKey: 'adminPrivate.tabs.inquiries' },
  { key: 'proposals', path: '/admin/private/proposals', labelKey: 'adminPrivate.tabs.proposals' },
  { key: 'suppliers', path: '/admin/private/suppliers', labelKey: 'adminPrivate.tabs.suppliers' },
  { key: 'partners', path: '/admin/private/partners', labelKey: 'adminPrivate.tabs.partners' },
  { key: 'performance', path: '/admin/private/performance', labelKey: 'adminPrivate.tabs.performance' },
  { key: 'settings', path: '/admin/private/settings', labelKey: 'adminPrivate.tabs.settings' },
];

export const INQUIRY_STAGES = [
  'new',
  'qualified',
  'quote_requested',
  'proposed',
  'client_accepted',
  'supplier_confirmed',
  'completed',
  'closed',
];

export const SUPPLIER_STATUSES = ['prospect', 'in_review', 'approved', 'suspended'];

export const SOURCES = ['advisor', 'concierge', 'direct', 'marketplace', 'other'];

export const REGIONS = ['italy', 'morocco', 'japan', 'other'];

export function privateNavValue(pathname) {
  if (pathname.startsWith('/admin/private/inquiries')) return '/admin/private/inquiries';
  if (pathname.startsWith('/admin/private/proposals')) return '/admin/private/proposals';
  if (pathname.startsWith('/admin/private/suppliers')) return '/admin/private/suppliers';
  if (pathname.startsWith('/admin/private/partners')) return '/admin/private/partners';
  if (pathname.startsWith('/admin/private/performance')) return '/admin/private/performance';
  if (pathname.startsWith('/admin/private/settings')) return '/admin/private/settings';
  return '/admin/private';
}

export function formatBudget(inquiry) {
  if (!inquiry) return '—';
  const { budgetMin, budgetMax, budgetCurrency } = inquiry;
  const currency = budgetCurrency || 'USD';
  if (budgetMin == null && budgetMax == null) return '—';
  if (budgetMin != null && budgetMax != null) {
    return `${currency} ${budgetMin.toLocaleString()}–${budgetMax.toLocaleString()} (indicative)`;
  }
  if (budgetMax != null) return `Up to ${currency} ${budgetMax.toLocaleString()} (indicative)`;
  return `From ${currency} ${budgetMin.toLocaleString()} (indicative)`;
}

export function destinationLabel(inquiry) {
  const list = inquiry?.destinations;
  if (!Array.isArray(list) || list.length === 0) return '—';
  return list.filter(Boolean).join(', ');
}
